define('presentation/common/routeToModal/presentationObjects/userGroupPresentationObject',[],function() {
    return function(){
        var self = this;
        self.groupId = null;
        self.groupName = null;
        self.type = "userGroup";
        self.avatar = null;
    };
});
